<template>
    <!-- Layout inner -->
    <div class="layout-inner dashbaord">
      <!-- Layout navbar -->
      <navbar></navbar>
      <!-- / Layout navbar -->
      <div class="layout-container">
        <div class="layout-content">
          <div v-if="!showPage" class="w-100 h-100 d-flex justify-content-center align-items-center">
            <spinner size="large"></spinner>
          </div>
          <template v-if="showPage">
            <div class="hd_bar">
              <div class="hd_ic">
                <span class="ic-summary"></span>
              </div>
              <div class="hd_txt">
                <span class="title_txt" id="userName">{{ $t('dashboardSummaryTitle', { name: userName }) }}</span>
              </div>

              <b-popover ref="userNamePopupContainer" target="userName" triggers="click" placement="top" class="title_popup" container="userNameContainer">
                <div class="title_container">
                  {{ $t('dashboardSummaryTitle', { name: userName }) }}
                </div>
                <div class="ic_container">
                  <span class="ic ic-close" v-on:click="hideUserNamePopup"></span>
                </div>
              </b-popover>
              <div id="userNameContainer" class="title_container_popup"></div>
            </div>


            <!-- Page content -->
            <div class="container-fluid flex-grow-1 pg_content_container">
              <b-tabs v-model="tabIndex" v-if="showPage">
                <b-tab no-body :title="$t('degreeProgress')" :title-link-class="linkClass(0)" :title-item-class="(careerGoal && isSkillTaggingEnabled) ? 'w-50 text-center' : 'w-100 text-center'">
                  <div v-if="showDonutLoader" class="w-100 mt-2">
                    <spinner size="large"></spinner>
                  </div>
                  <div class="alert alert-danger alert-dismissible fade show" v-if="isCourseSearchEnabled">
                    <button type="button" class="close" data-dismiss="alert">×</button>
                    {{ $t('coursePlanningMobileNotSupported') }}
                  </div>
                  <div class="row">

                    <div class="col-sm-12 col-xl-12 pg_content_sec">

                      <div class="row pg_content_row major_name" v-if="major">
                        <div class="col-12 pg_content_col">
                          <span class="content">
                            <template v-if="showMajorLabel">
                              {{majorLabel}} :
                            </template>
                            <span>{{major}}</span>
                          </span>
                        </div>
                      </div>

                      <div class="row pg_content_row advisor_name" v-if="advisorName">
                        <div class="col-12 pg_content_col">
                          <span class="content">
                            {{ $t('advisor') }} :
                            <span v-if="advisorName">{{advisorName}}</span>
                            <span class="no_data" v-else>{{ $t('notAvailable') }}</span>
                          </span>
                        </div>
                      </div>

                    </div>

                    <div class="col-sm-12 col-xl-12 pg_content_sec">
                      <div class="row pg_content_bar">

                        <!--
                        <div class="col-6 pg_content_col col_lft" v-if="majorGPA">
                          <div class="content_label">Major GPA</div>
                          <div class="content_value">{{majorGPA}}</div>
                        </div>
                        -->

                        <div class="col-12 pg_content_col col_rgt" v-if="overallGPA">
                          <div class="content_label">{{ $t('overallGpa') }}</div>
                          <div class="content_value">{{overallGPA}}</div>
                        </div>

                      </div>
                    </div>

                    <div class="col-sm-12 col-xl-12 pg_content_sec sec_credits_completed">
                      <div class="row pg_content_bar">

                        <div class="col-12 pg_content_col c1">
                          <span class="content_label">{{creditLabel}}s Completed</span>
                          <span class="content_value">{{overallCreditsCompleted}}/{{overallTotalCredits}}</span>
                        </div>

                      </div>
                    </div>

                    <div class="col-sm-12 col-xl-12 pg_content_sec">
                      <div class="row pg_content_row">

                        <div class="col-6 pg_content_col chart_container">
                          <div id="overallCreditCompletionChart"></div>
                        </div>

                        <div class="col-6 pg_content_col legends">
                          <div class="status_row"><span class="lg_blc gc_transferred"></span> {{ $t('transferred') }}</div>
                          <div class="status_row"><span class="lg_blc gc_completed"></span> {{ $t('completed') }}</div>
                          <div class="status_row"><span class="lg_blc gc_in_progress"></span> {{ $t('inProgress') }}</div>
                          <div class="status_row"><span class="lg_blc gc_in_scheduled"></span> {{ $t('scheduled') }} </div>
                          <div class="status_row"><span class="lg_blc gc_credits_needed"></span> {{creditLabel}}s Needed</div>
                          <!--
                          <div class="status_row"><span class="lg_blc gc_missing"></span>  Missing</div>
                          <div class="status_row"><span class="lg_blc gc_not_in_plan"></span>  Not in Plan</div>
                          -->
                        </div>

                      </div>

                      <div class="pg_content_row">
                        <div class="col-12 link_container">
                          <b-link @click="navigateToStreamDegree()">{{ $t('clickForDetails') }}</b-link>
                        </div>
                      </div>

                    </div>
                  </div>
                </b-tab>

                <b-tab no-body class="tab_career_progress" :title="$t('careerProgress')" :title-link-class="linkClass(1)" title-item-class="w-50 text-center" v-if="careerGoal && isSkillTaggingEnabled">
                  <div class="row">

                    <div class="col-sm-3 col-xl-3 pg_content_sec" v-if="outlook">
                      <div class="row pg_content_row major_details">

                        <div class="col-6 pg_content_col major_details_label">
                          <span class="content_label">{{careerGoal}}</span>
                          <span class="content_label">{{ $t('careerOutlook') }}</span>
                        </div>

                        <div class="col-6 pg_content_col major_details_value">
                          <div class="content_value">{{outlook}}</div>

                          <div class="outlook_icon_container" v-if="outlook === 'Bright'">
                            <span class="ic ic-brightFull"></span>
                            <span class="ic ic-brightFull"></span>
                            <span class="ic ic-brightFull"></span>
                          </div>

                          <div class="outlook_icon_container" v-if="outlook === 'Average'">
                            <span class="ic ic-brightFull"></span>
                            <span class="ic ic-brightHalfFull"></span>
                            <span class="ic ic-brightEmpty"></span>
                          </div>

                          <div class="outlook_icon_container" v-if="outlook === 'Below-average'">
                            <span class="ic ic-brightFull"></span>
                            <span class="ic ic-brightEmpty"></span>
                            <span class="ic ic-brightEmpty"></span>
                          </div>

                        </div>

                      </div>
                    </div>


                    <div class="col-sm-3 col-xl-3 pg_content_sec">
                      <div class="row pg_content_bar">

                        <div class="col-6 pg_content_col col_lft">
                          <div class="content_label">{{ $t('growthIn10Years') }}</div>
                          <div class="content_value" v-if="growth">{{growth}}%</div>
                          <div class="content_value" v-else>{{ $t('notAvailable') }}</div>
                          <div class="content_info"></div>
                        </div>

                        <div class="col-6 pg_content_col col_rgt">
                          <div class="content_label">{{ $t('numberOfJobs') }}</div>
                          <div class="content_value" v-if="openings">{{Number(openings).toLocaleString()}}</div>
                          <div class="content_value" v-else>{{ $t('notAvailable') }}</div>
                          <div class="content_info">{{ $t('inLast12Months') }}</div>
                        </div>

                      </div>
                    </div>


                    <div class="col-sm-3 col-xl-3 pg_content_sec" v-show="isCareerProgressGenerated">
                      <div class="row pg_content_row">

                        <div class="col-6 pg_content_col chart_container">
                          <div id="overallSkillCompletionChart"></div>
                        </div>

                        <div class="col-6 pg_content_col legends">
                          <div class="status_row"><span class="lg_blc gc_completed"></span> {{ $t('completed') }}</div>
                          <div class="status_row"><span class="lg_blc gc_in_progress"></span> {{ $t('inProgress') }}</div>
                          <div class="status_row"><span class="lg_blc gc_in_plan"></span> {{ $t('inThePlan') }}</div>
                          <div class="status_row"><span class="lg_blc gc_missing"></span>  {{ $t('missing') }}</div>
                        </div>

                      </div>

                      <div class="pg_content_row">
                        <div class="col-12 link_container">
                          <b-link @click="navigateToStreamCareer()">{{ $t('clickForDetails') }}</b-link>
                        </div>
                      </div>

                    </div>

                  </div>

                </b-tab>
              </b-tabs>

            </div>
            <!-- / Page content -->

            <!-- Footer Navbar -->
            <footer-navbar></footer-navbar>
            <!-- / Footer Navbar -->
          </template>
        </div>
      </div>
    </div>
    <!-- Layout inner -->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Navbar from '../../misc/components/./Navbar'
import FooterNavbar from '../../misc/components/./FooterNavbar'
import * as d3 from 'd3'
import { PACKAGE } from '../../../package_constants'

export default {
  name: 'dashboard',
  props: [],
  components: {
    Navbar,
    FooterNavbar
  },
  data: () => {
    return {
      advisor: {},
      tabIndex: 0,
      growth: null,
      outlook: null,
      openings: null,
      skillProgressLabelMap: {
        'completed': 'completed',
        'inProgress': 'inProgress',
        'planned': 'inThePlan',
        'missing': 'missing'
      },
      isCareerProgressGenerated: false,
      showLoader: false,
      showDonutLoader: false,
      showPage: false
    }
  },

  mounted () {
    this.loadDashboard()
  },

  methods: {
    ...mapActions([
      'loadPlanningStream',
      'loadUserObj',
      'loadInstitutionDetail',
      'loadInstitutionPackage',
      'loadCareeDetail',
      'loadCareerOneStopInfo',
      'loadUserAdvisor'
    ]),
    linkClass (idx) {
      if (this.tabIndex === idx) {
        return ['active']
      } else {
        return ['bg-primary', 'text-light']
      }
    },
    navigateToStreamDegree () {
      return this.$router.push({ name: 'streamDegree', params: { uuid: this.planningStream.uuid } })
    },
    async loadDashboard () {
      this.showDonutLoader = true
      await this.loadUserObj()
      let res = await this.loadInstitutionDetail(this.userObj.institutionId)
      await this.loadInstitutionPackage({uuid: res.uuid, isAggregated: false})
      if (this.isLearnerDashboardEnabled) {
        if(res.learnerDashboard && (res.learnerDashboard.indexOf('modern')!=-1)){
          return this.$router.push({name: 'modernDashboard'})
        }else{
          return this.$router.push({name: 'learnerDashboard'})
        }
      }
      if (!this.isDashboardEnabled && !this.isCourseSearchEnabled) {
        if (this.isExplorePackageEnabled) {
          return this.$router.push({ name: 'exploreIntro' })
        } else {
          return this.$router.push({ name: 'courses' })
        }
      }
      this.showPage = true
      if (this.careerGoal) {
        let career = await this.loadCareeDetail(this.careerGoal)
        if (career) {
          let careerOneStop = (career.source !== 'COS') ? await this.loadCareerOneStopInfo(career.code) : {}
          this.growth = career.growth || careerOneStop.growth
          this.outlook = career.outlook || careerOneStop.outlook
          this.openings = career.openingsDoubleFormat || careerOneStop.openingsDoubleFormat
          if (!this.openings) {
            this.openings = career.openings || careerOneStop.openings
          }
        }
      }
      await this.loadPlanningStream()
      this.advisor = await this.loadUserAdvisor(this.userObj.uuid)
      if (this.planningStream && this.planningStream.programGuides[0] && this.planningStream.programGuides[0].progress) {
        let colorScale = {
          'transferred': '#56b5e8',
          'completed': '#508102',
          'in progress': '#9fc958',
          'scheduled': '#f5b518',
          'credits needed': '#d07b08',
          'not in plan': '#969696',
          'in the plan': '#1eb1eb'
        }
        this.generatePieChart(this.planningStream.programGuides[0].progress.values, colorScale, 'overallCreditCompletionChart')
      }
      if (this.planningStream && this.planningStream.careerProgress && this.planningStream.careerProgress.progressByTypeMap) {
        let total = this.planningStream.careerProgress.progressByTypeMap.TOTAL
        if (total) {
          let keys = Object.keys(total)
          let data = []
          keys.forEach(key => {
            let value = total[key]
            let label = this.skillProgressLabelMap[key]
            if (label && value > 0) {
              data.push({label: label, value: value})
            }
          })
          let colorScale = {
            'completed': '#508102',
            'inProgress': '#9fc958',
            'inThePlan': '#f5b518',
            'missing': '#e5250c'
          }
          this.isCareerProgressGenerated = true
          this.generatePieChart(data, colorScale, 'overallSkillCompletionChart')
        }
      }
      this.showDonutLoader = false
    },
    getLabel (label) {
      const labelKeyMap = {
        'transferred': 'transferred',
        'completed': 'completed',
        'in progress': 'inProgress',
        'scheduled': 'scheduled',
        'credits needed': 'creditsNeeded',
        'not in plan': 'notInPlan',
        'in the plan': 'inThePlan',
        'missing': 'missing',
        'inprogress': 'inProgress',
        'intheplan': 'inThePlan'
      }
      const key = labelKeyMap[(label || '').toLowerCase().replace(/\s+/g, ' ')] || labelKeyMap[(label || '').toLowerCase()]
      if (key) {
        return this.$t(key)
      }
      if (label.indexOf('credits') !== -1) {
        return label.replace('credit', this.creditLabel.toLowerCase())
      }
      return label
    },
    generatePieChart (data, colorScale, elementId) {
      var pieChartContainerHeight = 162
      var pieChartInnerRadius = 35
      var width = pieChartContainerHeight
      var height = pieChartContainerHeight
      var radius = pieChartContainerHeight / 2

      var tooltip = d3.select('body')
                    .append('div')
                    .style('position', 'absolute')
                    .style('z-index', '10')
                    .style('visibility', 'hidden')
                    .style('color', '#111')
                    .attr('class', 'report-tooltip-xaxis')
                    .style('padding', '8px')
                    .style('border-radius', '6px')
                    .style('font', 'bold 15px Arial')
                    .text('tooltip')

      var canvas = d3.select('#' + elementId).append('svg')
                   .data([data]).attr('width', width).attr('height', height).append('g')
                   .attr('transform', 'translate(' + radius + ',' + radius + ')')

      var arc = d3.arc()
                .outerRadius(radius)
                .innerRadius(pieChartInnerRadius)

      var pie = d3.pie()
                .value(function (d) { return d.value }).sort(null)

      var arcs = canvas.selectAll('.arc')
                 .data(pie(data))
                 .enter().append('g')
                 .attr('class', 'arc')

      arcs.append('path')
          .attr('d', arc)
          .style('fill', (d, i) => { return colorScale[d.data.label] })
          .on('mouseover', (d) => {
            tooltip.text(this.getLabel(d.data.label) + ': ' + d.data.value + (''))
            tooltip.style('visibility', 'visible')
          })
          .on('mousemove', function () {
            return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
          })
          .on('mouseout', function () {
            return tooltip.style('visibility', 'hidden')
          })

      arcs.append('text')
          .attr('transform', (d) => { return 'translate(' + arc.centroid(d) + ')' })
          .style('font', 'bold 12px Arial')
          .style('fill', '#fff')
          .style('cursor', 'default')
          .attr('text-anchor', 'middle')
          .text((d) => { return d.data.value })
          .on('mouseover', (d) => {
            tooltip.text(this.getLabel(d.data.label) + ': ' + d.data.value + (''))
            tooltip.style('visibility', 'visible')
          })
          .on('mousemove', () => {
            return tooltip.style('top', (d3.event.pageY - 25) + 'px').style('left', (($(window).width() - 150) > d3.event.pageX ? (d3.event.pageX + 10) : (d3.event.pageX - 130)) + 'px')
          })
          .on('mouseout', () => {
            return tooltip.style('visibility', 'hidden')
          })
    },
    navigateToStreamCareer () {
      return this.$router.push({ name: 'streamCareer', params: { uuid: this.planningStream.uuid } })
    },
    hideUserNamePopup () {
      this.$refs.userNamePopupContainer.$emit('close')
    }
  },

  computed: {
    ...mapState({
      'userObj': state => state.login.userObj,
      'planningStream': state => state.dashboard.stream,
      'enabledFeatures': state => state.dashboard.enabledFeatures
    }),
    showMajorLabel () {
      let studentProgressFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STUDENT_PROGRESS_FEATURE_ID]
      if (studentProgressFeature) {
        let flags = studentProgressFeature.flags
        for (var i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'showMajorLabel') {
            return flag.enabled
          }
        }
      }
      return false
    },
    majorLabel () {
      let studentProgressFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.STUDENT_PROGRESS_FEATURE_ID]
      if (studentProgressFeature) {
        let flags = studentProgressFeature.flags
        for (var i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'showMajorLabel' && $.trim(flag.label).length > 0) {
            return flag.label
          }
        }
      }
      return this.$t('major')
    },
    creditLabel () {
      let creditLabelFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.CUSTOM_CREDIT_LABEL_FEATURE_ID]
      if (!creditLabelFeature || !creditLabelFeature.enabled || !creditLabelFeature.label) {
        return this.$t('credit')
      }
      return creditLabelFeature.label
    },
    userName () {
      if (this.userObj) {
        return this.userObj.firstName + ' ' + this.userObj.lastName
      } else {
        return ''
      }
    },
    major () {
      if (this.userObj) {
        return this.userObj.major1Title
      } else {
        return ''
      }
    },
    majorGPA () {
      if (this.userObj && this.userObj.majorGpa) {
        return parseFloat(this.userObj.majorGpa).toFixed(3)
      } else {
        return ''
      }
    },
    overallGPA () {
      if (this.userObj && this.userObj.overallGpa) {
        return parseFloat(this.userObj.overallGpa).toFixed(3)
      } else {
        return ''
      }
    },
    overallCreditsCompleted () {
      if (this.planningStream.programGuides && this.planningStream.programGuides.length > 1 && this.planningStream.programGuides[0].progress) {
        return this.planningStream.programGuides[0].progress.completed + this.planningStream.programGuides[0].progress.transfered
      }
      return '-'
    },
    overallTotalCredits () {
      if (this.planningStream.programGuides && this.planningStream.programGuides.length > 1 && this.planningStream.programGuides[0].progress) {
        return this.planningStream.programGuides[0].progress.total
      }
      return '-'
    },
    careerGoal () {
      return this.userObj.careerGoal
    },
    isSkillTaggingEnabled () {
      let skillTaggingFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SKILL_TAGGING_FEATURE_ID]
      if (skillTaggingFeature) {
        return skillTaggingFeature.enabled
      }
      return false
    },
    isDashboardEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature) {
        return progressViewFeature.enabled
      }
      return false
    },
    isCourseSearchEnabled () {
      let courseSearchFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.COURSE_SEARCH_FEATURE_ID]
      if (courseSearchFeature) {
        return courseSearchFeature.enabled
      }
      return false
    },
    isExplorePackageEnabled () {
      let exploreFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_FEATURE_ID]
      if (exploreFeature && exploreFeature.enabled) {
        return true
      }
      return false
    },
    isLearnerDashboardEnabled () {
      let learnerDashboardFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.SHOW_LEARNER_DASHBOARD_FEATURE_ID]
      if (learnerDashboardFeature) {
        return learnerDashboardFeature.enabled
      }
      return false
    },
    advisorName () {
      if (this.advisor) {
        return this.advisor.name
      } else {
        return null
      }
    }
  },

  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/dashboard/components/Dashboard.vue